import { AddCircle, CheckBox, CheckBoxOutlineBlank, Close, Edit, ExpandLess, ExpandMore, Inventory, Person } from '@mui/icons-material';
import { Alert, Avatar, Box, Button, Card, CardContent, CardMedia, Chip, Collapse, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, MenuItem, Stack, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { apiGet, apiPost, AppModels, appRegistry, appUrl, BarcodeLookupProductInfo, brandNewProduct, brandNewProductCategory, brandNewTool, brandNewWarehouse, deleteModel, FileAttrs, getRelatedItemProductTools, getUserProducts, getWarehouseProducts, getWarehouseProductTools, hasErrors, InventoryState, Lang, MESURE, NfcTagAttrs, nfcTagSlice, ProductAttrs, productByBarCode, productCategorySlice, ProductImageIdentificationResponse, productSelector, productSlice, productToolsBySeqNumber, routeParams, saveModel, ScanModeViewMode, ScanViewModeSlice, SearchProductResult, SearchResult, selectNfcTag, ToolAttrs, toolSelector, toolsSlice, UserAttrs, userSelector, userSlice, WAREHOUSE_CODE_MAX_LENGTH, WarehouseAttrs, warehouseSelector, warehouseSlice, warehouseSubtreeIds } from 'cdx-common';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useHashParams } from '../../libraries/hashParams';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { useToaster } from '../../libraries/Toaster';
import { UpdatableImage, UploadableFileList } from '../../libraries/UploadManager';
import { AppState, appStore } from '../../store';
import { AppItemAvatar, LocationLoader, ShowWarehouseCode, UserLoader, WarehouseCodeMode, WarehouseLoader } from '../AppItems';
import { LocationTextfield } from '../location/LocationTextfield';
import { MasterViewPage } from '../MasterPage';
import { SuperSearchInput } from '../SuperSearchInput';
import { BarcodeIcon } from '../utils/BarcodeIcon';
import { LoadingBackdrop } from '../utils/LoadingBackdrop';
import { ModelTextfield } from '../utils/ModelTextField';
import { MyDatePicker } from '../utils/MyDatePicker';
import { BarcodeScanDialog } from './BarcodeScanDialog';
import { MobileScanModeLayout } from './MobileScanModeLayout';
import { ProductImagePicker } from './ProductImagePicker';
import { ScanModeLayout } from './ScanModeLayout';
import { useScanWatcher } from './ScanWatcher';


const Item = (props: { children: React.ReactNode; }) => {
    return <Box sx={{ p: 1, }}>{props.children}</Box>;
};

export const ScanProductsModeView = () => {

    return <MasterViewPage>
        <MainSimpleViewLoader
            path={routeParams.scanProductsMode.path}>
            <LoadedScanModeView />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

const LoadedScanModeView = () => {


    const navigate = useNavigate();
    const scanwatch = useScanWatcher();
    const hashParams = useHashParams();
    const [searchParams] = useSearchParams();
    const mode = hashParams.get('mode') as ScanModeViewMode | null;
    const theme = useTheme();
    const isMdOrLarger = useMediaQuery(
        theme.breakpoints.up('md')
    );


    const newTool = useSelector((state: AppState) => state.scanViewMode.newTool);
    const currentTool = useSelector((state: AppState) => toolSelector.selectById(state, hashParams.get('inventoryId') ?? ''));

    const elementEnModeTagAjout = useSelector((state: AppState) => state.scanViewMode.modeAjoutTag);
    const editingTool = useSelector((state: AppState) => state.scanViewMode.editingTool);

    const warehouseSelected = useSelector((state: AppState) => state.scanViewMode.toolsThatHasWarehouseSelected);
    const userSelected = useSelector((state: AppState) => state.scanViewMode.tootlThatHasUserSelected);
    const toolThatHasBarcodeSelected = useSelector((state: AppState) => state.scanViewMode.toolThatHasBarcodeSelected);
    const navigateWithScanMode = useSelector((state: AppState) => state.scanViewMode.navigateWithScanMode);

    const inventoryId = hashParams.get('inventoryId') as ModelId | null;

    React.useEffect(() => {
        appStore.dispatch(ScanViewModeSlice.actions.setisMdOrLarger(isMdOrLarger));
    }, [isMdOrLarger]);

    React.useEffect(() => {
        appStore.dispatch(ScanViewModeSlice.actions.initUserToolSelected());
        appStore.dispatch(ScanViewModeSlice.actions.initWarehouseToolSelected());
    }, [hashParams, searchParams]);

    React.useEffect(() => {

        const onToolScan = (tool: ToolAttrs) => {

            if (elementEnModeTagAjout || toolThatHasBarcodeSelected) return;
            console.log('navigateWithScanMode', navigateWithScanMode);

            //if (navigateWithScanMode) {
            appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(false));
            navigate(appUrl('scanProductsMode', null, { id: tool.productId, type: AppModels.products }, { inventoryId: tool.id, mode: ScanModeViewMode.INVENTORY }));
            //}
        };

        const onProductScan = (product: ProductAttrs) => {

            if (elementEnModeTagAjout || toolThatHasBarcodeSelected) return;

            //if (navigateWithScanMode) {
            appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(false));
            navigate(appUrl('scanProductsMode', undefined, { id: product.id, type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));
            //}
        };

        const onUPCCodeScan = (result: SearchProductResult) => {

            if (elementEnModeTagAjout || toolThatHasBarcodeSelected) return;

            console.log('result', result);

            if (result) {
                if (result[0].length === 1) {
                    if (result[1].length === 1) {
                        appStore.dispatch(productSlice.actions.upsertOne(result[1][0]));
                        navigate(appUrl('scanProductsMode', undefined, { id: result[1][0].id, type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));
                    } else {
                        appStore.dispatch(ScanViewModeSlice.actions.setSelectedWebProduct(result[0][0]));
                        navigate(appUrl('scanProductsMode', undefined, { id: 'non-existant', type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));
                    }
                } else if (result.length > 1) {
                    appStore.dispatch(productSlice.actions.upsertMany(result[1]));
                    appStore.dispatch(ScanViewModeSlice.actions.setWebSearchResult(result[0]));
                    navigate(routeParams.scanProductsMode.path);
                }
            }
        };

        const onRelatedElementScan = async (type: AppModels, id: ModelId) => {

            if (elementEnModeTagAjout || toolThatHasBarcodeSelected) return;

            /*
            if (navigateWithScanMode) {
                switch (type) {
                    case AppModels.users:
                    case AppModels.warehouses:
                        appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(false));
                        navigate(appUrl('scanProductsMode', undefined, { id, type }, { mode: ScanModeViewMode.DETAILS }));
                        return;
                    default:
                        break;
                }
            }
            */
            if (type == AppModels.warehouses) {
                if (warehouseSelected.length) {
                    await Promise.all(warehouseSelected.map(async (p) => {
                        const response = await saveModel<ToolAttrs>(AppModels.tools, { id: p, warehouseId: id });
                        if (!hasErrors(response)) {
                            appStore.dispatch(toolsSlice.actions.updateOne({ id: response.id, changes: response }));
                            if (editingTool?.id == p) {
                                appStore.dispatch(ScanViewModeSlice.actions.updateEditingTool({
                                    warehouseId: response.warehouseId
                                }));
                            }
                        }
                    }));
                    appStore.dispatch(ScanViewModeSlice.actions.initWarehouseToolSelected());
                } else if (currentTool && !currentTool.warehouseId) {
                    const response = await saveModel<ToolAttrs>(AppModels.tools, { id: currentTool.id, warehouseId: id });
                    if (!hasErrors(response)) {
                        appStore.dispatch(toolsSlice.actions.updateOne({ id: response.id, changes: response }));
                        appStore.dispatch(ScanViewModeSlice.actions.updateEditingTool({
                            warehouseId: response.warehouseId
                        }));
                    }
                } else {
                    appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(false));
                    navigate(appUrl('scanProductsMode', undefined, { id, type }, { mode: ScanModeViewMode.DETAILS }));
                }
            } else if (type == AppModels.users) {
                if (userSelected.length) {
                    await Promise.all(userSelected.map(async (p) => {
                        const response = await saveModel<ToolAttrs>(AppModels.tools, { id: p, userId: id });
                        if (!hasErrors(response)) {
                            appStore.dispatch(toolsSlice.actions.updateOne({ id: response.id, changes: response }));
                            if (editingTool?.id == p) {
                                appStore.dispatch(ScanViewModeSlice.actions.updateEditingTool({
                                    userId: response.userId
                                }));
                            }
                        }
                    }));
                    appStore.dispatch(ScanViewModeSlice.actions.initUserToolSelected());
                } else if (currentTool && !currentTool.warehouseId) {
                    const response = await saveModel<ToolAttrs>(AppModels.tools, { id: currentTool.id, userId: id });
                    if (!hasErrors(response)) {
                        appStore.dispatch(toolsSlice.actions.updateOne({ id: response.id, changes: response }));
                        appStore.dispatch(ScanViewModeSlice.actions.updateEditingTool({
                            userId: response.warehouseId
                        }));
                    }
                } else {
                    appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(false));
                    navigate(appUrl('scanProductsMode', undefined, { id, type }, { mode: ScanModeViewMode.DETAILS }));
                }
            }


        };
        const onLocalBarCodeScan = async (code: string) => {

            console.log('onLocalBarCodeScan', code, elementEnModeTagAjout, toolThatHasBarcodeSelected);

            if (navigateWithScanMode) return;

            if (elementEnModeTagAjout) {
                const response = await apiPost('scanModeTagElement', {
                    ...elementEnModeTagAjout,
                    tagId: code,
                });
                console.log('onLocalBarCodeScan response', response);
                if (typeof response == 'string') {
                    alert(response);
                } else {
                    appStore.dispatch(nfcTagSlice.actions.upsertOne(response));
                    appStore.dispatch(ScanViewModeSlice.actions.setModeAjoutTag(undefined));
                }
            } else if (toolThatHasBarcodeSelected) {
                const response = await saveModel<ToolAttrs>(AppModels.tools, { id: toolThatHasBarcodeSelected, barCode: code });
                if (typeof response == 'string') {
                    alert(response);
                } else {
                    appStore.dispatch(toolsSlice.actions.upsertOne(response));
                    appStore.dispatch(ScanViewModeSlice.actions.setToolThatHasCodebarSelected(undefined));
                    if (editingTool?.id == toolThatHasBarcodeSelected) {
                        appStore.dispatch(ScanViewModeSlice.actions.updateEditingTool({
                            barCode: response.barCode
                        }));
                    }
                }
            }
        };

        scanwatch.onProductScanned(onProductScan);
        scanwatch.onUPCCodeScanned(onUPCCodeScan);
        scanwatch.onRelatedElementScanned(onRelatedElementScan);
        scanwatch.onLocalBarCodeScanned(onLocalBarCodeScan);
        scanwatch.onToolScanned(onToolScan);

        return () => {
            scanwatch.offProductScanned(onProductScan);
            scanwatch.offUPCCodeScanned(onUPCCodeScan);
            scanwatch.offRelatedElementScanned(onRelatedElementScan);
            scanwatch.offLocalBarCodeScanned(onLocalBarCodeScan);
            scanwatch.offToolScanned(onToolScan);
        };
    }, [newTool, elementEnModeTagAjout, navigateWithScanMode, toolThatHasBarcodeSelected, warehouseSelected, userSelected, currentTool]);

    return <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {isMdOrLarger ? <ScanModeLayout
            topChildren={<Box sx={{ width: '100%', textAlign: 'center' }}><Typography>Mode Code Barre | <Link to={'/'}>Retour à l'acccueil</Link></Typography></Box>}
            leftChildren={<ProductListView />}
            topRightChildren={<TopRightView />}
            bottomRightChildren={<InventoryDetails />}
            showBottomRightPanel={!!inventoryId}
        /> : <MobileScanModeLayout
            topChildren={<Box sx={{ width: '100%', textAlign: 'center' }}><Typography variant="body2">Mode Code Barre | <Link to={'/'}>Retour à l'accueil</Link></Typography></Box>}
            mainChildren={mode === ScanModeViewMode.INVENTORY ? <InventoryDetails /> : ((mode === ScanModeViewMode.DETAILS || mode === ScanModeViewMode.EDIT_SUBJECT) ? <TopRightView /> : <ProductListView />)}
        />}
    </Box>;
};

const TopRightView = () => {
    const hashParams = useHashParams();
    const [searchParams] = useSearchParams();
    const mode = hashParams.get('mode') as ScanModeViewMode | null;

    switch (mode) {
        case ScanModeViewMode.EDIT_SUBJECT:
            switch (searchParams.get('type')) {
                case AppModels.products:
                    return <EditProductView />;
                case AppModels.warehouses:
                    return <WarehouseEditView />;
                case AppModels.users:
                default:
                    return <></>;
            }
        default:
            switch (searchParams.get('type')) {
                case AppModels.products:
                    return <ProductView />;
                case AppModels.warehouses:
                    return <WarehouseView />;
                case AppModels.users:
                    return <UserView />;
                default:
                    return <></>;
            }

    }
};


const WebProductListItem = (props: { product: BarcodeLookupProductInfo; }) => {

    const navigate = useNavigate();

    const linkedProduct = useSelector((state: AppState) => productByBarCode(state, props.product.barcode_number));

    const onClick = () => {
        appStore.dispatch(ScanViewModeSlice.actions.setSelectedWebProduct(props.product));
        navigate(appUrl('scanProductsMode', undefined, { id: props.product?.productId ?? 'non-existant', type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));
    };

    return <ListItemButton onClick={onClick} selected={!!props.product.barcode_number && !!linkedProduct} alignItems="flex-start">
        <ListItemAvatar>
            <Avatar alt="Remy Sharp" src={props.product.images?.[0] ?? ''} variant="square" />
        </ListItemAvatar>
        <ListItemText
            primary={<Typography sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical'
            }}>{props.product.title}</Typography>}
            secondary={
                <Typography sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical'
                }}>
                    {props.product.description}
                </Typography>
            }
        />
    </ListItemButton>;
};

const ProductListItem = (props: { product: ProductAttrs; }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const relatedType = searchParams.get('type');
    const relatedId = searchParams.get('id');
    const canAddInventory = !!relatedId && (relatedType === AppModels.users || relatedType === AppModels.warehouses);

    const onClick = () => {
        appStore.dispatch(ScanViewModeSlice.actions.setSelectedWebProduct(undefined));
        navigate(appUrl('scanProductsMode', undefined, { id: props.product.id, type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));
    };



    const attr = useMemo((): keyof ToolAttrs | null => {
        switch (searchParams.get('type')) {
            case AppModels.users:
                return 'userId';
            case AppModels.warehouses:
                return 'warehouseId';
            default:
                return null;
        }
    }, [searchParams]);

    const onAddInventoryClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        const id = searchParams.get('id');
        const t = attr === 'warehouseId'
            ? tools.find(tool => tool.warehouseId === id)
            : tools[0];
        if (props.product.quantityUnit != MESURE.UNITE && t) {
            const response = await saveModel<ToolAttrs>(AppModels.tools, {
                ...t,
                quantity: t.quantity + 1,
            });
            if (!hasErrors(response)) {
                appStore.dispatch(toolsSlice.actions.upsertOne(response));
            }
            return;
        }
        if (attr && id) {
            const response = await saveModel<ToolAttrs>(AppModels.tools, {
                ...brandNewTool,
                productId: props.product.id,
                [attr]: id
            });
            if (!hasErrors(response)) {
                appStore.dispatch(toolsSlice.actions.upsertOne(response));
            }
        }
    };

    const tools = useSelector((state: AppState) => attr === 'warehouseId'
        ? getWarehouseProductTools(state, searchParams.get('id') ?? '', props.product.id)
        : attr
            ? getRelatedItemProductTools(state, attr, searchParams.get('id') ?? '', props.product.id)
            : []);
    const currQte = useMemo(() => {
        return tools.reduce((acc, curr) => { return acc + curr.quantity; }, 0);
    }, [tools]);

    return <ListItem disablePadding>
        <ListItemButton
            onClick={onClick}
            alignItems="flex-start"
            sx={{ minWidth: 0, flex: '1 1 auto' }}
        >
            <ListItemAvatar>
                <AppItemAvatar type={AppModels.products} model={props.product} variant="square" />
            </ListItemAvatar>
            <ListItemText
                sx={{ minWidth: 0 }}
                primary={<Typography sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '1',
                    WebkitBoxOrient: 'vertical'
                }}>{props.product.name}</Typography>}
                secondary={
                    <Typography variant='caption' sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '2',
                        WebkitBoxOrient: 'vertical'
                    }}>
                        {props.product.description}
                    </Typography>
                }
            />
        </ListItemButton>
        {canAddInventory && <Button
            type="button"
            size="small"
            variant="outlined"
            aria-label="Ajouter un inventaire"
            title="Ajouter un inventaire"
            onClick={onAddInventoryClick}
            sx={{ minWidth: 56, ml: 1, mr: 1, flexShrink: 0 }}
        >
            <AddCircle />{currQte > 0 ? currQte + '+1' : ''} {props.product.quantityUnit == MESURE.UNITE ? '' : Lang(`MESURE_SHORT.${props.product.quantityUnit}`)}
        </Button>}
    </ListItem>;
};

const WarehouseListItem = (props: { warehouse: WarehouseAttrs; }) => {
    const navigate = useNavigate();

    const onClick = () => {
        appStore.dispatch(ScanViewModeSlice.actions.setSelectedWebProduct(undefined));
        navigate(appUrl('scanProductsMode', undefined, { id: props.warehouse.id, type: AppModels.warehouses }, { mode: ScanModeViewMode.DETAILS }));
    };



    return <ListItemButton onClick={onClick} alignItems="flex-start">
        <ListItemAvatar>
            <AppItemAvatar type={AppModels.warehouses} model={props.warehouse} variant="square" />
        </ListItemAvatar>
        <ListItemText
            primary={<Typography sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical'
            }}>{props.warehouse.name}</Typography>}
        />
    </ListItemButton>;
};

const UserListItem = (props: { user: UserAttrs; }) => {
    const navigate = useNavigate();

    const onClick = () => {
        appStore.dispatch(ScanViewModeSlice.actions.setSelectedWebProduct(undefined));
        navigate(appUrl('scanProductsMode', undefined, { id: props.user.id, type: AppModels.users }, { mode: ScanModeViewMode.DETAILS }));
    };



    return <ListItemButton onClick={onClick} alignItems="flex-start">
        <ListItemAvatar>
            <AppItemAvatar type={AppModels.users} model={props.user} variant="square" />
        </ListItemAvatar>
        <ListItemText
            primary={<Typography sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical'
            }}>{props.user.name}</Typography>}
        />
    </ListItemButton>;
};

const SearchListItem = (props: { searchResultItem: SearchResult; }) => {
    switch (props.searchResultItem.model) {
        case AppModels.products:
            return <ProductListItem product={props.searchResultItem.data as ProductAttrs} />;
        case AppModels.warehouses:
            return <WarehouseListItem warehouse={props.searchResultItem.data as WarehouseAttrs} />;
        case AppModels.users:
            return <UserListItem user={props.searchResultItem.data as UserAttrs} />;
        default:
            return <></>;
    }
};



const ProductListView = () => {

    const query = useSelector((state: AppState) => state.scanViewMode.query);
    const searchTimout = useSelector((state: AppState) => state.scanViewMode.searchTimout);
    const webSearchResult = useSelector((state: AppState) => state.scanViewMode.webSearchResult);
    const searchResult = useSelector((state: AppState) => state.scanViewMode.searchResult);
    const [canSearchWeb, setCanSearchWeb] = React.useState(false);
    const [barcodeDialogOpen, setBarcodeDialogOpen] = React.useState(false);
    const lastSearchedQueryRef = React.useRef<string | null>(null);
    const navigateWithScanMode = useSelector((state: AppState) => state.scanViewMode.navigateWithScanMode);
    const navigate = useNavigate();

    const searchFromWeb = async () => {
        if (query && query.length > 3) {
            const result = await apiGet('scanModeSearchProduct', undefined, { query });
            if (result) {
                appStore.dispatch(productSlice.actions.upsertMany(result[1]));
                appStore.dispatch(ScanViewModeSlice.actions.setWebSearchResult(result[0]));
                setCanSearchWeb(false);
            }
        }
    };

    const searchFromServer = async () => {
        if (query && query.length > 3) {
            lastSearchedQueryRef.current = query;
            const result = await apiGet('search', undefined, { query, filterModels: [AppModels.products, AppModels.users, AppModels.warehouses] });
            if (result) {
                const products = result.filter(p => p.model == AppModels.products).map(p => (p.data as ProductAttrs));
                const users = result.filter(p => p.model == AppModels.users).map(p => (p.data as UserAttrs));
                const warehouses = result.filter(p => p.model == AppModels.warehouses).map(p => (p.data as WarehouseAttrs));
                appStore.dispatch(productSlice.actions.upsertMany(products));
                appStore.dispatch(userSlice.actions.upsertMany(users));
                appStore.dispatch(warehouseSlice.actions.upsertMany(warehouses));
                appStore.dispatch(ScanViewModeSlice.actions.setSearchResult(result));
                appStore.dispatch(ScanViewModeSlice.actions.setWebSearchResult(undefined));
                setCanSearchWeb(true);
            }
        }
    };

    React.useEffect(() => {
        if (searchTimout) {
            clearTimeout(searchTimout);
        }
        if (query && query.length > 3 && query !== lastSearchedQueryRef.current) {
            setTimeout(() => {
                searchFromServer();
            }, 700);
        }
        return () => {
            if (searchTimout) {
                clearTimeout(searchTimout);
            }
        };
    }, [query]);

    /*
    const onCodeBarClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.currentTarget.blur();
        appStore.dispatch(ScanViewModeSlice.actions.setNavigateWithScanMode(!navigateWithScanMode));
    };
    */

    const onWebLookClick = () => {
        searchFromWeb();
    };

    const onCodeBarClick = () => {
        setBarcodeDialogOpen(true);
    };

    const onBarcodeDetected = (code: string) => {
        // Reprend exactement le pipeline utilise par le lecteur physique
        // (ScanWatcher) : recherche produit/outil/tag NFC local ou UPC.
        appStore.dispatch(ScanViewModeSlice.actions.setCodeScanned(code));
    };

    const onCreateClick = async () => {
        brandNewProduct;
        const response = await saveModel(AppModels.products, {
            ...brandNewProduct,
            name: query
        });
        if (!hasErrors(response)) {
            appStore.dispatch(productSlice.actions.upsertOne(response));
            navigate(appUrl('scanProductsMode', undefined, { id: response.id, type: AppModels.products }, { mode: ScanModeViewMode.EDIT_SUBJECT }));
        }
    };

    const onProductImagesIdentified = (response: ProductImageIdentificationResponse) => {
        const singleResult = response.results.length === 1 ? response.results[0] : null;
        const existingProduct = singleResult?.productId
            ? response.existingProducts.find(product => product.id === singleResult.productId)
            : undefined;

        if (existingProduct) {
            appStore.dispatch(productSlice.actions.upsertOne(existingProduct));
            navigate(appUrl('scanProductsMode', undefined, {
                id: existingProduct.id,
                type: AppModels.products
            }, { mode: ScanModeViewMode.DETAILS }));
            return;
        }

        appStore.dispatch(productSlice.actions.upsertMany(response.existingProducts));
        appStore.dispatch(ScanViewModeSlice.actions.setWebSearchResult(response.results));
        setCanSearchWeb(false);
    };

    return <div>
        <Box
            component="form"
            sx={{ p: 1, display: 'flex', alignItems: 'stretch', gap: 1 }}
            noValidate
            autoComplete="off"
        >
            <TextField
                fullWidth
                sx={{ flex: 1 }}
                id="outlined-controlled"
                label="Rechercher produit, entrepot, employé ..."
                value={query}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    appStore.dispatch(ScanViewModeSlice.actions.setQuery(event.target.value));
                }}
            />

            <Button
                type="button"
                variant={navigateWithScanMode ? 'contained' : "outlined"}
                aria-label="Lire un code à barre"
                title="Lire un code à barre"
                onClick={onCodeBarClick}
                sx={{ minWidth: 56, px: 1.5 }}
            >
                <BarcodeIcon />
            </Button>
            <ProductImagePicker
                disabled={navigateWithScanMode}
                onIdentified={onProductImagesIdentified}
            />
            <BarcodeScanDialog
                open={barcodeDialogOpen}
                onClose={() => setBarcodeDialogOpen(false)}
                onDetected={onBarcodeDetected}
            />
        </Box>
        <Box>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {webSearchResult ?
                    webSearchResult.map((p, index) => <WebProductListItem key={`${p.productId ?? p.barcode_number ?? ''}-${index}`} product={p} />) :
                    searchResult.map(p => <SearchListItem key={p.id} searchResultItem={p} />)}
                {(webSearchResult?.length || !canSearchWeb) ? null : <ListItemButton onClick={onWebLookClick} alignItems="flex-start">
                    <ListItemText
                        primary={'Rechercher sur BARCODE LOOKUP'}
                    />
                </ListItemButton>}
                {!!query && <ListItemButton onClick={onCreateClick} alignItems="flex-start">
                    <ListItemText
                        primary={<Typography>Créer «{query}»</Typography>}
                    />
                </ListItemButton>}
            </List>
        </Box>
    </div>;
};

const ProductView = () => {
    return <><ProductDetailsView /><ProductToolList /></>;
};

const WarehouseView = () => {


    return <><WarehouseDetailsView /><WarehouseProductList /></>;
};

const UserView = () => {
    return <><UserDetailsView /><UserProductList /></>;
};

export default function ProductCard(props: { image: string | null; title: string; description: string; }) {

    return (
        <Card sx={{ display: 'flex' }}>
            <CardMedia
                component="img"
                sx={{ height: 180, maxWidth: 180, objectFit: 'contain', backgroundColor: '#f0f0f0' }}
                image={props.image || undefined}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Typography component="div" variant="h5" sx={{ display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                        {props.title}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary', display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3 }}
                    >
                        {props.description}
                    </Typography>
                </CardContent>
            </Box>

        </Card>
    );
}
const LinkedItemCard = () => {

    const [searchParams] = useSearchParams();
    const elementEnModeTagAjout = useSelector((state: AppState) => state.scanViewMode.modeAjoutTag);
    const tags = useSelector((state: AppState) => selectNfcTag(state, searchParams.get('type') as AppModels, searchParams.get('id')));

    const onDeleteTag = async (model: NfcTagAttrs) => {
        if (confirm("Supprimer ce code barre ?")) {
            const response = await deleteModel(AppModels.nfcTags, model.id);
            if (response === true) {
                appStore.dispatch(nfcTagSlice.actions.removeOne(model.id));
            }
        }
    };

    const onAjouter = async () => {
        const type = searchParams.get('type');
        const id = searchParams.get('id');
        console.log('ajouter', searchParams.get('type'), searchParams.get('id'));
        if (type && id) {
            appStore.dispatch(ScanViewModeSlice.actions.setModeAjoutTag({ type: type as AppModels, id }));
        }
    };

    return <>
        {elementEnModeTagAjout && <LoadingBackdrop caption='Scannez un code à barre' onCancel={() => {
            appStore.dispatch(ScanViewModeSlice.actions.setModeAjoutTag(undefined));
        }} />}
        <>
            <Typography component="div">
                Code à barre liés <Button size="small" onClick={onAjouter}>Ajouter</Button>
            </Typography>
            <Typography component="div">
                {tags?.map(tag => <Chip label={tag.tagId} onDelete={() => { onDeleteTag(tag); }} />)}
            </Typography>
        </>
    </>;
};

const ProductDetailsView = () => {

    const [searchParams] = useSearchParams();
    const hashParams = useHashParams();

    const currentTool = useSelector((state: AppState) => toolSelector.selectById(state, hashParams.get('inventoryId') ?? ''));
    const selectedProduct = useSelector((state: AppState) => state.scanViewMode.selectedWebProduct);
    const product = useSelector((state: AppState) => productSelector.selectById(state, searchParams.get('id') ?? currentTool?.productId ?? '0'));

    if (product) {
        return <ProductCard
            image={product.image}
            title={product.name}
            description={product.description} />;

    } else if (selectedProduct) {
        return <ProductCard
            image={selectedProduct.images?.[0] ?? null}
            title={selectedProduct.title}
            description={selectedProduct.description} />;

    } else {
        return <Box sx={{ p: 1 }}><Typography>Sélectionner un produit</Typography></Box>;
    }
};

const WarehouseEditView = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const warehouseId = searchParams.get('id') ?? '';
    const warehouse = useSelector((state: AppState) => warehouseSelector.selectById(state, warehouseId));
    const editingWarehouse = useSelector((state: AppState) => state.scanViewMode.editingWarehouse);
    const descendantIds = useSelector((state: AppState) => warehouseSubtreeIds(state, warehouseId));


    const onLocationChanged = async (locationId: ModelId) => {
        update({ locationId: locationId });
    };
    const onSetEmptyLocation = () => {
        update({ locationId: null });
    };

    const update = (changes: Partial<WarehouseAttrs>) => {
        const remainingErrors = { ...(editingWarehouse?.__errors ?? {}) };
        for (const field of Object.keys(changes)) {
            delete remainingErrors[field];
        }
        appStore.dispatch(ScanViewModeSlice.actions.updateEditingWarehouse({
            ...changes,
            __err: changes.__err,
            __errors: Object.keys(remainingErrors).length ? remainingErrors : undefined
        }));
    };

    const save = async () => {
        if (!editingWarehouse) return;
        const validated = appRegistry.get(AppModels.warehouses)?.validator?.validate(editingWarehouse) ?? editingWarehouse;
        if (hasErrors(validated)) {
            appStore.dispatch(ScanViewModeSlice.actions.setEditingWarehouse(validated));
            return;
        }

        const result = await saveModel<WarehouseAttrs>(AppModels.warehouses, validated);
        if (hasErrors(result)) {
            appStore.dispatch(ScanViewModeSlice.actions.setEditingWarehouse(result));
            return;
        }

        appStore.dispatch(warehouseSlice.actions.upsertOne(result));
        appStore.dispatch(ScanViewModeSlice.actions.setEditingWarehouse(result));
        navigate(appUrl('scanProductsMode', undefined, {
            id: result.id,
            type: AppModels.warehouses
        }, { mode: ScanModeViewMode.DETAILS }));
    };

    const onParentSelected = (_type: AppModels, parentWarehouseId: ModelId, data: WarehouseAttrs) => {
        const createsCycle = parentWarehouseId === editingWarehouse?.id || descendantIds.has(parentWarehouseId);
        update({
            parentWarehouseId,
            locationId: data.locationId,
            __err: createsCycle
                ? 'Un emplacement ne peut pas être placé sous lui-même ou sous un de ses enfants.'
                : undefined
        });
    };

    const changed = !!warehouse && !!editingWarehouse && JSON.stringify(warehouse) !== JSON.stringify(editingWarehouse);

    if (editingWarehouse) {
        return <Box sx={{ p: 2 }}>
            <Button variant='outlined' onClick={() => navigate(appUrl('scanProductsMode', undefined, {
                id: editingWarehouse.id,
                type: AppModels.warehouses
            }, { mode: ScanModeViewMode.DETAILS }))}>Retour à l'emplacement</Button>
            <Typography variant="h5" sx={{ mt: 2 }}>Modifier l'emplacement</Typography>
            {!!editingWarehouse.__err && <Alert severity="error" sx={{ mt: 2 }}>{editingWarehouse.__err}</Alert>}
            <Item>
                <ModelTextfield
                    fullWidth
                    model={editingWarehouse}
                    modelType={AppModels.warehouses}
                    row='name'
                    value={editingWarehouse.name ?? ''}
                    onChange={event => update({ name: event.target.value, __err: undefined })}
                />
            </Item>
            <Item>
                <ModelTextfield
                    fullWidth
                    model={editingWarehouse}
                    modelType={AppModels.warehouses}
                    row='code'
                    value={editingWarehouse.code ?? ''}
                    inputProps={{ maxLength: WAREHOUSE_CODE_MAX_LENGTH }}
                    onChange={event => update({ code: event.target.value, __err: undefined })}
                />
            </Item>
            <Item>
                <SuperSearchInput
                    placeholder='Emplacement parent'
                    filter={[AppModels.warehouses]}
                    value={editingWarehouse.parentWarehouseId ? {
                        type: AppModels.warehouses,
                        id: editingWarehouse.parentWarehouseId
                    } : undefined}
                    onItemSelected={onParentSelected}
                    onSetEmpty={() => update({ parentWarehouseId: null, __err: undefined })}
                    textfieldProps={{
                        error: !!editingWarehouse.__err,
                        helperText: editingWarehouse.__err
                    }}
                />
            </Item>
            <Item>
                {editingWarehouse.parentWarehouseId
                    ? <Box>
                        <Typography variant='caption'>Emplacement / adresse hérité du parent</Typography>
                        <LocationLoader
                            id={editingWarehouse.locationId}
                            render={location => <Typography>{location.name}</Typography>}
                        />
                    </Box>
                    : <LocationTextfield
                        value={editingWarehouse.locationId}
                        onChange={onLocationChanged}
                        onSetEmpty={onSetEmptyLocation} />}
            </Item>
            <Item>
                <Button disabled={!changed} variant='contained' onClick={save}>Enregistrer</Button>
            </Item>
        </Box>;
    }
    return <></>;
};

const WarehouseDetailsView = () => {

    const [searchParams] = useSearchParams();
    const hashParams = useHashParams();

    const warehouse = useSelector((state: AppState) => warehouseSelector.selectById(state, searchParams.get('id') ?? ''));


    const editWarehouseClick = () => {
        if (warehouse) {
            // manually update tool draft
            appStore.dispatch(ScanViewModeSlice.actions.setEditingWarehouse({ ...warehouse }));

            hashParams.set({
                mode: ScanModeViewMode.EDIT_SUBJECT
            });
        }
    };



    if (warehouse) {
        return <Card sx={{ display: 'flex' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Typography component="div" variant="h5" sx={{ display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                        {warehouse.name}
                    </Typography>
                    <Typography component="div" variant="body2">Code : {warehouse.code}</Typography>
                    {!!warehouse.parentWarehouseId && <Typography component="div" variant="caption">
                        Parent : <WarehouseLoader
                            id={warehouse.parentWarehouseId}
                            render={parent => <>{parent.code} — {parent.name}</>}
                        />
                    </Typography>}
                    {!!warehouse.locationId && <LocationLoader id={warehouse.locationId} render={location => <Typography component="div" variant="caption">{location.name}</Typography>} />}
                    <Button variant='outlined' onClick={editWarehouseClick}>Modifier cet emplacement</Button>
                </CardContent>
                <CardContent sx={{ flex: '1 0 auto' }}>

                </CardContent>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <LinkedItemCard />
                </CardContent>
            </Box>
        </Card>;
    }
    return <></>;
};
const UserDetailsView = () => {

    const [searchParams] = useSearchParams();
    //const hashParams = useHashParams();

    const user = useSelector((state: AppState) => userSelector.selectById(state, searchParams.get('id') ?? ''));

    if (user) {
        return <Card sx={{ display: 'flex' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Typography component="div" variant="h5" sx={{ display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                        {user.name}
                    </Typography>

                </CardContent>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <LinkedItemCard />
                </CardContent>
            </Box>
        </Card>;
    }
    return <></>;
};

const StockOrSide = (props: { first: React.ReactNode, second: React.ReactNode; }) => {
    const isMdOrLarger = useSelector((state: AppState) => state.scanViewMode.isMdOrLarger);
    return isMdOrLarger ? <>{props.first}{props.second}</> : <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1 }}>{props.first}</Box>
        <Box sx={{ flex: 1 }}>{props.second}</Box>
    </Box>;
};

const ToolListItem = (props: { tool: ToolAttrs; }) => {

    const hashParams = useHashParams();
    const [searchParams] = useSearchParams();
    const currentTool = useSelector((state: AppState) => toolSelector.selectById(state, hashParams.get('inventoryId') ?? ''));
    const warehouseSelected = useSelector((state: AppState) => state.scanViewMode.toolsThatHasWarehouseSelected);
    const userSelected = useSelector((state: AppState) => state.scanViewMode.tootlThatHasUserSelected);
    const toolThatHasBarcodeSelected = useSelector((state: AppState) => state.scanViewMode.toolThatHasBarcodeSelected);
    const product = useSelector((state: AppState) => productSelector.selectById(state, props.tool.productId));
    const [quantity, setQuantity] = useState(props.tool.quantity + '');
    const userThatHasCurrentTool = useSelector((state: AppState) => userSelector.selectById(state, props.tool?.userId ?? ''));
    const warehouseThatHasCurrentTool = useSelector((state: AppState) => warehouseSelector.selectById(state, props.tool?.warehouseId ?? ''));


    useEffect(() => {
        setQuantity(props.tool.quantity + '');
    }, [props.tool.id]);

    const showToolClick = () => {

        // manually update tool draft
        appStore.dispatch(ScanViewModeSlice.actions.setEditingTool({ ...props.tool }));

        hashParams.set({
            inventoryId: props.tool.id,
            mode: ScanModeViewMode.INVENTORY
        });
    };

    const onWarehouseClick = (event: React.MouseEvent<HTMLElement>) => {
        event.currentTarget.blur();
        if (toolThatHasBarcodeSelected) return;

        event.stopPropagation();
        appStore.dispatch(ScanViewModeSlice.actions.setWarehouseToolSelected({
            id: props.tool.id,
            selected: !warehouseSelected?.includes(props.tool.id)
        }));
    };

    const onCodeBarClick = (event: React.MouseEvent<HTMLElement>) => {
        event.currentTarget.blur();
        if (warehouseSelected?.length || userSelected?.length) return;
        event.stopPropagation();

        appStore.dispatch(ScanViewModeSlice.actions.setToolThatHasCodebarSelected(toolThatHasBarcodeSelected == props.tool.id ? undefined : props.tool.id));

    };

    const onUserClick = (event: React.MouseEvent<HTMLElement>) => {
        event.currentTarget.blur();
        if (toolThatHasBarcodeSelected) return;
        event.stopPropagation();
        appStore.dispatch(ScanViewModeSlice.actions.setUserToolSelected({
            id: props.tool.id,
            selected: !userSelected?.includes(props.tool.id)
        }));
        /*
        setPickUser(true);
        */
    };

    const normalizedQuantity = useMemo<number | null>(() => {
        const trimmedQuantity = quantity.trim();

        if (trimmedQuantity === '0') return 0;

        if (!trimmedQuantity) return null;

        const numericQuantity = Number(trimmedQuantity);

        if (!Number.isFinite(numericQuantity) || numericQuantity < 0) return null;

        if (product?.quantityUnit === MESURE.UNITE && !Number.isInteger(numericQuantity)) {
            return null;
        }

        return numericQuantity;
    }, [quantity, product?.quantityUnit]);

    const isASignletonProduct = Boolean(props.tool.quantity === 1 && product?.quantityUnit == MESURE.UNITE);

    if (!product) return;


    return <>
        {!!props.tool.warehouseId && <WarehouseLoader
            id={props.tool.warehouseId} />}
        {!!props.tool.userId && <UserLoader id={props.tool.userId} />}
        <ListItem
            onClick={showToolClick}
            sx={{ bgColor: currentTool?.id === props.tool.id ? 'rgb(216, 227, 243)' : 'background.paper', cursor: 'pointer' }}
            secondaryAction={<React.Fragment>
                <Chip disabled={toolThatHasBarcodeSelected !== undefined} color={warehouseSelected?.includes(props.tool.id) ? 'primary' : 'default'} variant={props.tool.warehouseId ? 'outlined' : undefined} avatar={<Inventory />} label={warehouseThatHasCurrentTool ? <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '70px' }}><ShowWarehouseCode id={props.tool.warehouseId} mode={searchParams.get('type') == AppModels.warehouses ? WarehouseCodeMode.CURRENT : WarehouseCodeMode.MAIN} /></Typography> : undefined} onClick={onWarehouseClick} />
                {isASignletonProduct ? <>
                    {searchParams.get('type') == AppModels.users ? null : <Chip disabled={toolThatHasBarcodeSelected !== undefined} color={userSelected?.includes(props.tool.id) ? 'primary' : 'default'} variant={props.tool.userId ? 'outlined' : undefined} avatar={<Person />} label={userThatHasCurrentTool?.code ?? ''} onClick={onUserClick} />}
                    <Chip disabled={warehouseSelected?.length > 0 || userSelected?.length > 0 || quantity != '1' || !!props.tool.barCode} color={toolThatHasBarcodeSelected == props.tool.id ? 'primary' : 'default'} variant={props.tool.barCode ? 'outlined' : undefined} avatar={<BarcodeIcon />} label={props.tool.barCode ? <CheckBox /> : <CheckBoxOutlineBlank />} onClick={onCodeBarClick} />
                </> : undefined}

            </React.Fragment>}>
            <React.Fragment>
                <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1 }}>
                    <StockOrSide
                        first={isASignletonProduct && <Typography>{'Stock #' + (props.tool.seqNumber.toString().padStart(3, '0'))}</Typography>}
                        second={<>{props.tool.barCode == '' && <TextField

                            size='small'
                            type="number"
                            color={normalizedQuantity === null ? 'error' : undefined}
                            disabled={props.tool.barCode != ''}
                            sx={{ width: 100, m: 0, p: 0 }}
                            slotProps={{
                                htmlInput: {
                                    step: product.quantityUnit == MESURE.UNITE ? 1 : 0.01,
                                    min: 0
                                }
                            }}
                            value={quantity}
                            onChange={event => {
                                setQuantity(event.target.value);
                            }}
                            onClick={(event) => { event.stopPropagation(); }}
                            onBlur={async () => {
                                if (normalizedQuantity) {
                                    const response = await saveModel<ToolAttrs>(AppModels.tools, { id: props.tool.id, quantity: normalizedQuantity });
                                    if (!hasErrors(response)) {
                                        appStore.dispatch(toolsSlice.actions.upsertOne(response));
                                    }
                                }
                            }}
                        />}
                            {props.tool.barCode == '' && product.quantityUnit != MESURE.UNITE && <Typography>{Lang(`MESURE_SHORT.${product.quantityUnit}`)}</Typography>}
                        </>}
                    />
                </Box>
            </React.Fragment>

        </ListItem></>;
};
const ProductToolList = () => {

    const [searchParams] = useSearchParams();
    const hashParams = useHashParams();

    const currentTool = useSelector((state: AppState) => toolSelector.selectById(state, hashParams.get('inventoryId') ?? ''));

    const tools = useSelector((state: AppState) => productToolsBySeqNumber(state, searchParams.get('id') ?? currentTool?.productId ?? ''));
    const selectedProduct = useSelector((state: AppState) => state.scanViewMode.selectedWebProduct);
    const product = useSelector((state: AppState) => productSelector.selectById(state, searchParams.get('id') ?? currentTool?.productId ?? ''));
    const [loading, setLoading] = React.useState('');

    const navigate = useNavigate();

    const onAddClick = async () => {
        if (product) {

            const result = await apiPost('scanModeAddStock', {
                productId: product.id,
            });
            if (result) {
                appStore.dispatch(toolsSlice.actions.upsertOne(result));
                appStore.dispatch(ScanViewModeSlice.actions.setNewTool(result));
            }
            //navigate(appUrl('scanModeProduct', { productId: result.productId, inventoryId: result.id }));
            // C'est un produit existant. Créer un nouveau stock !
        } else if (selectedProduct) {
            setLoading('Création du produit...');
            // Produit de barcodelookup inexisant. À créer, puis rediriger vers ce produit !
            try {
                const result = await apiPost('scanModeAddStockToNewUpcProduct', {
                    ...selectedProduct
                });
                if (result) {
                    appStore.dispatch(ScanViewModeSlice.actions.setNewTool(result.inventory));
                    navigate(appUrl('scanProductsMode', undefined, { id: result.product.id, type: AppModels.products }, { mode: ScanModeViewMode.DETAILS }));

                }
                setLoading('');
            } catch (err) {
                setLoading('');
            }
        }
    };

    const onEditProductClick = () => {
        if (product) {
            navigate(appUrl('scanProductsMode', undefined, { id: product.id, type: AppModels.products }, { mode: ScanModeViewMode.EDIT_SUBJECT }));
        }
    };

    return <Box>
        {loading !== '' ? <LoadingBackdrop caption={loading} /> : null}
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <Stack direction="row" spacing={2}>
                {!!product ? <>
                    <Button variant='outlined' onClick={onAddClick} startIcon={<AddCircle />}>Ajouter</Button>
                    <Button variant='outlined' onClick={onEditProductClick} startIcon={<Edit />}>Modifier la fiche produit</Button>
                </> : <>
                    <Button variant='outlined' onClick={onAddClick} startIcon={<AddCircle />}>Ajouter à la liste de produits</Button>
                </>}</Stack>
            {tools?.map((p: ToolAttrs) => <ToolListItem key={p.id} tool={p} />)}
        </List>
    </Box>;
};


const WarehouseProductList = () => {

    const [searhParams] = useSearchParams();
    const products = useSelector((state: AppState) => getWarehouseProducts(state, searhParams.get('id') ?? ''));
    return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>{products.map(p => <RelatedItemProductListItem key={'product' + p.id} toolKey='warehouseId' product={p} />)};</List>;
};

const UserProductList = () => {

    const [searhParams] = useSearchParams();
    const products = useSelector((state: AppState) => getUserProducts(state, searhParams.get('id') ?? ''));
    return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>{products.map(p => <RelatedItemProductListItem key={'product' + p.id} toolKey='userId' product={p} />)};</List>;
};

const RelatedItemProductListItem = (props: { product: ProductAttrs, toolKey: keyof ToolAttrs; }) => {

    const [open, setOpen] = React.useState(false);

    const [searhParams] = useSearchParams();

    const managePerTools = props.product.quantityUnit === MESURE.UNITE;

    const handleClick = () => {
        setOpen(!open);
    };

    const tools = useSelector((state: AppState) => props.toolKey === 'warehouseId'
        ? getWarehouseProductTools(state, searhParams.get('id') ?? '', props.product.id)
        : getRelatedItemProductTools(state, props.toolKey, searhParams.get('id') ?? '', props.product.id));

    return <>
        <ListItemButton onClick={handleClick} alignItems="flex-start">
            <ListItemAvatar>
                <AppItemAvatar type={AppModels.products} model={props.product} variant="square" />
            </ListItemAvatar>
            <ListItemText
                primary={<Typography sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '1',
                    WebkitBoxOrient: 'vertical'
                }}>{props.product.name}</Typography>}
                secondary={
                    <Typography variant='caption'>
                        Quantité {tools.reduce((acc, curr) => { return acc + curr.quantity; }, 0)} ({Lang(`MESURE.${props.product.quantityUnit}`)})
                    </Typography>
                }
            />
            {managePerTools ? (open ? <ExpandLess /> : <ExpandMore />) : null}

        </ListItemButton>
        {managePerTools ? <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                {tools.map(tool => <ToolListItem tool={tool} key={'tool' + tool.id} />)}
            </List>
        </Collapse> : null}
    </>;
};

const InventoryDetails = () => {

    const hashParams = useHashParams();
    const { toast } = useToaster();
    const tool = useSelector((state: AppState) => toolSelector.selectById(state, hashParams.get('inventoryId') ?? ''));
    const product = useSelector((state: AppState) => productSelector.selectById(state, tool?.productId ?? ''));
    const editingTool = useSelector((state: AppState) => state.scanViewMode.editingTool);
    const navigate = useNavigate();
    const isMdOrLarger = useSelector((state: AppState) => state.scanViewMode.isMdOrLarger);

    React.useEffect(() => {
        appStore.dispatch(ScanViewModeSlice.actions.setEditingTool(tool));
    }, [hashParams.get('inventoryId')]);





    const save = async (update: Partial<ToolAttrs>) => {
        if (tool) {
            const updated = { ...tool, ...update };
            await saveModel(AppModels.tools, updated);
            appStore.dispatch(toolsSlice.actions.upsertOne(updated));
            appStore.dispatch(ScanViewModeSlice.actions.setEditingTool(updated));
        }
    };

    const hasChanged = useMemo(() => {
        if (!tool || !editingTool) {
            return false;
        }
        return tool.serialNumber !== editingTool.serialNumber ||
            tool.barCode !== editingTool.barCode ||
            tool.warranty !== editingTool.warranty ||
            tool.dateBought !== editingTool.dateBought ||
            tool.state !== editingTool.state ||
            tool.userId !== editingTool.userId ||
            tool.warehouseId !== editingTool.warehouseId;
    }, [tool, editingTool]);



    const update = (update: Partial<ToolAttrs>) => {
        if (editingTool) {
            const updated = { ...editingTool, ...update };
            appStore.dispatch(ScanViewModeSlice.actions.setEditingTool(updated));
        }
    };

    const onCloseClick = () => {
        hashParams.set('inventoryId', '');
        //navigate(appUrl('scanProductsMode', undefined, { id: searchParams.get('id'), type: searchParams.get('type') }, { mode: ScanModeViewMode.PRODUCT_DETAILS }));
    };

    if (!tool) {
        return <Box><Typography>Sélectionner un outil</Typography></Box>;
    }
    if (!editingTool) {
        return <Box><Typography>Chargement...</Typography></Box>;
    }

    if (editingTool.id !== tool.id) return <></>;

    const isASignletonProduct = Boolean(editingTool.quantity === 1 && product?.quantityUnit == MESURE.UNITE);

    return <Box sx={{ p: 2, marginBottom: '20px', position: 'relative' }}>
        {isMdOrLarger ? <Box sx={{ float: 'right', textAlign: 'right' }}><Button onClick={onCloseClick}><Close /></Button></Box> : <List>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <AppItemAvatar type={AppModels.products} model={product} variant="square" />
                </ListItemAvatar>
                <ListItemText
                    primary={product.name} />
            </ListItem>
        </List>}
        <Item>
            <Typography variant="h5">Modifier l'inventaire # {(tool.seqNumber.toString().padStart(3, '0'))}</Typography>
        </Item>
        <Item>
            {!!editingTool.warehouseId && <Box><strong>Emplacement: </strong> <ShowWarehouseCode id={editingTool.warehouseId} mode={WarehouseCodeMode.ALL} /></Box>}
            <SuperSearchInput
                placeholder={'Emplacement / entrepôt'}
                filter={[AppModels.warehouses]}
                value={editingTool.warehouseId ? { type: AppModels.warehouses, id: editingTool.warehouseId } : undefined}
                onItemSelected={(_type: AppModels, id: ModelId) => {
                    update({ warehouseId: id });
                }}
                onCreate={async (name) => {
                    const newWareHouse: WarehouseAttrs = {
                        ...brandNewWarehouse,
                        name,
                        code: name.trim().slice(0, WAREHOUSE_CODE_MAX_LENGTH).toUpperCase()
                    };
                    const result = await saveModel(AppModels.warehouses, newWareHouse);
                    if (!hasErrors(result)) {
                        update({ warehouseId: result.id });
                    } else {
                        toast.error(`Impossible de créer l'enplacement / entrepôt`);
                    }
                }}
                onSetEmpty={() => {
                    update({ warehouseId: null });
                }}
                onGotoElement={editingTool.warehouseId ? () => {
                    const id = editingTool.warehouseId;
                    if (id) {
                        navigate(appUrl('scanProductsMode', undefined, { id, type: AppModels.warehouses }, { mode: ScanModeViewMode.DETAILS }));
                    }
                } : undefined}
            />
        </Item>
        {isASignletonProduct ? <>
            <Item>
                <TextField
                    select
                    fullWidth
                    label="État de l'inventaire"
                    value={editingTool.state}
                    onChange={event => update({ state: event.target.value as InventoryState })}
                >
                    <MenuItem value={InventoryState.OK}>En bon état</MenuItem>
                    <MenuItem value={InventoryState.DEFECT}>Brisé</MenuItem>
                    <MenuItem value={InventoryState.REPAIRING}>En réparation</MenuItem>
                    <MenuItem value={InventoryState.DISPOSED}>Jeté</MenuItem>
                </TextField>
            </Item>
            <Item>
                <SuperSearchInput
                    placeholder={'Utilisateur'}
                    filter={[AppModels.users]}
                    value={editingTool.userId ? { type: AppModels.users, id: editingTool.userId } : undefined}
                    onItemSelected={(_type: AppModels, id: ModelId) => {
                        update({ userId: id });
                    }}
                    onSetEmpty={() => {
                        update({ userId: null });
                    }}
                    onGotoElement={editingTool.userId ? () => {
                        const id = editingTool.userId;
                        if (id) {
                            navigate(appUrl('scanProductsMode', undefined, { id, type: AppModels.users }, { mode: ScanModeViewMode.DETAILS }));
                        }
                    } : undefined}
                />
            </Item>
            <Item>
                <ModelTextfield
                    fullWidth
                    model={editingTool}
                    modelType={AppModels.tools}
                    row='serialNumber'
                    value={editingTool.serialNumber ?? ''}
                    onChange={event => update({ serialNumber: event.target.value })}
                />
            </Item>

            <Item>
                <ModelTextfield
                    fullWidth
                    model={editingTool}
                    modelType={AppModels.tools}
                    row='barCode'
                    value={editingTool.barCode ?? ''}
                    disabled={product.quantityUnit !== MESURE.UNITE}
                    onChange={event => update({ barCode: event.target.value })}
                    helperText={product.quantityUnit !== MESURE.UNITE ? "Pour des produits unitaires uniquement" : undefined}
                />

            </Item>

            <Item>
                <ModelTextfield
                    fullWidth
                    rows={4}
                    multiline
                    model={editingTool}
                    modelType={AppModels.tools}
                    row='warranty'
                    value={editingTool.warranty ?? ''}
                    onChange={event => update({ warranty: event.target.value })}
                />
            </Item>

            <Item>
                <MyDatePicker
                    name='dateBought'
                    label="Date d'achat"
                    value={editingTool.dateBought ? editingTool.dateBought : ''}
                    onChange={date => update({ dateBought: date ? date : null })}
                /></Item>


        </> :
            <>
                <Item>
                    <ModelTextfield
                        fullWidth
                        model={editingTool}
                        modelType={AppModels.tools}
                        row='quantity'
                        type='number'
                        slotProps={{
                            htmlInput: {
                                step: product.quantityUnit == MESURE.UNITE ? 1 : 0.01,
                                min: 0
                            }
                        }}
                        value={editingTool.quantity ?? ''}
                        onChange={event => {
                            const v = parseFloat(event.target.value);
                            if (v) {
                                update({ quantity: v });
                            }
                        }}
                    />
                </Item>
            </>}

        {!!tool && tool.barCode && <>
            <Typography variant='h5'>Images / Photos du produit</Typography>
            <UploadableFileList
                canUpload={true}
                canRemove={true}
                accept={['jpg', 'jpeg', 'png']}
                relation={{ type: AppModels.tools, id: tool.id }} />
        </>}

        <Box sx={{ textAlign: 'left', p: 2, }}>
            <Button disabled={!hasChanged} variant='contained' onClick={() => save(editingTool)}>Enregistrer</Button>
        </Box>
    </Box >;
};


const EditProductView = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const product = useSelector((state: AppState) => productSelector.selectById(state, searchParams.get('id') ?? ''));
    const [editingProduct, setEditingProduct] = React.useState<ProductAttrs>({ ...product });

    React.useEffect(() => {
        if (product) {
            setEditingProduct({ ...product });
        }
    }, []);

    const save = async () => {
        const validated = await appRegistry.get(AppModels.products)?.validator?.validate(editingProduct);
        if (hasErrors(validated)) {
            setEditingProduct(validated);
        } else {
            const result = await saveModel<ProductAttrs>(AppModels.products, validated);
            if (!hasErrors(result)) {
                appStore.dispatch(productSlice.actions.upsertOne(result));
                setEditingProduct(p => {
                    return { ...p, ...result };
                });
            }

        }
    };
    const changed = useMemo(() => {
        if (!product) {
            return false;
        }
        return JSON.stringify(product) !== JSON.stringify(editingProduct);
    }, [product, editingProduct]);

    const onCreateProductCategory = async (name: string) => {
        const newProductCategory = {
            ...brandNewProductCategory,
            name
        };
        const result = await saveModel(AppModels.productCategories, newProductCategory);

        appStore.dispatch(productCategorySlice.actions.upsertOne(result));
        setEditingProduct({ ...editingProduct, productCategoryId: result.id });
    };

    const onBackClick = () => {
        navigate(appUrl('scanProductsMode', undefined, { id: product?.id ?? undefined, type: product?.id ? AppModels.products : undefined }, { mode: ScanModeViewMode.DETAILS }));
    };

    if (!product) {
        return <Box><Typography>Produit non trouvé</Typography></Box>;
    }


    return <Box sx={{ p: 2 }}>
        <Button variant='outlined' onClick={onBackClick}>Retour à la fiche produit</Button>
        <Typography variant="h5">Modifier le produit</Typography>
        <Item>
            <UpdatableImage canUpload={true} value={editingProduct.imageFileId} relation={{ type: AppModels.products, id: editingProduct.id }} onUpdated={(file: FileAttrs) => {
                console.log('file', file);
                setEditingProduct({
                    ...editingProduct,
                    imageFileId: file.id,
                    image: file.url
                });
            }}
                onRemoved={() => {
                    setEditingProduct({
                        ...editingProduct,
                        imageFileId: null,
                        image: null
                    });
                }} />
        </Item>

        <Item>
            <ModelTextfield
                fullWidth
                model={editingProduct}
                modelType={AppModels.products}
                row='name'
                value={editingProduct.name ?? ''}
                onChange={event => setEditingProduct({ ...editingProduct, name: event.target.value })}
            />
        </Item>

        <Item>
            <ModelTextfield
                fullWidth
                model={editingProduct}
                modelType={AppModels.products}
                row='barCode'
                value={editingProduct.barCode ?? ''}
                onChange={event => setEditingProduct({ ...editingProduct, barCode: event.target.value })}
            />

        </Item>

        {/*
        <Item>
            <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Type de suivi d'inventaire</FormLabel>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={editingProduct.type}
                    onChange={event => {
                        setEditingProduct({ ...editingProduct, type: event.target.value as ProductType });
                        appStore.dispatch(deviceStoreSlice.actions.setNewProductType(event.target.value as ProductType));
                    }}>
                    <FormControlLabel value={ProductType.TOOL} control={<Radio />} label="Unitaire" />
                    <FormHelperText>{'Chaque produit est unique, peut être tracé et identifié et a une durée de vie (outil, véhicule, etc)'}</FormHelperText>
                    <FormControlLabel value={ProductType.CONSUMABLE} control={<Radio />} label="Quantitatif" />
                    <FormHelperText>{'Suivi des quantité uniquement (Clous par boite, caisse et/ou poids)'}</FormHelperText>
                </RadioGroup>
            </FormControl>
        </Item> */ }

        <Item>
            <TextField
                select
                fullWidth
                label="Unité de mesure"
                value={editingProduct.quantityUnit}
                onChange={event => setEditingProduct({ ...editingProduct, quantityUnit: event.target.value as MESURE })}
            >
                {Object.entries(MESURE).map(([key, unit]) => (
                    <MenuItem key={unit} value={unit}>{Lang(`MESURE.${key}`)}</MenuItem>
                ))}
            </TextField>
        </Item>

        <Item>
            <ModelTextfield
                fullWidth
                rows={4}
                multiline
                model={editingProduct}
                modelType={AppModels.products}
                row='description'
                value={editingProduct.description ?? ''}
                onChange={event => setEditingProduct({ ...editingProduct, description: event.target.value })}
            />

        </Item>
        <Item>
            <SuperSearchInput
                filter={[AppModels.brands]}
                value={editingProduct.fabricantId ? { type: AppModels.companies, id: editingProduct.fabricantId } : undefined}
                textfieldProps={{
                    label: 'Fabricant'
                }}
                onItemSelected={(_type: AppModels, id: ModelId) => {
                    setEditingProduct({ ...editingProduct, fabricantId: id });
                }}
            />
        </Item>
        <Item>
            <SuperSearchInput
                filter={[AppModels.productCategories]}
                value={editingProduct.productCategoryId ? { type: AppModels.productCategories, id: editingProduct.productCategoryId } : undefined}
                onItemSelected={(_type: AppModels, id: ModelId) => {
                    setEditingProduct({ ...editingProduct, productCategoryId: id });
                }}
                textfieldProps={{
                    label: 'Catégrorie'
                }}
                onCreate={(value) => {
                    onCreateProductCategory(value);
                }}
            />
        </Item>
        <Box sx={{ textAlign: 'left', p: 2, }}>
            <Button disabled={!changed} variant='contained' onClick={save}>Enregistrer</Button>
        </Box>
    </Box>;
};
